// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2584":"3d086431","8688":"c979e12a"}[chunkId] + ".chunk.css";
};